export default "/assets/Icon/Crossmint.png"